import { surveyPublicLogoUrl } from '@releve/shared';

/**
 * The public URL of a survey's logo snapshot (the `survey-public` bucket) —
 * the same string the API builds for the respondent (`surveyPublicLogoUrl`
 * in `@releve/shared`), from the browser-facing `VITE_SUPABASE_URL`. Pure
 * string building: no request, no session. NULL without a path.
 */
export function surveyLogoUrl(path: string | null | undefined): string | null {
  return surveyPublicLogoUrl((import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '', path);
}

/** Extensions the API's create-time logo copy can admit (it sniffs PNG / JPEG / WebP bytes, ≤ 1 MB). */
const COPYABLE_LOGO_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp']);

/**
 * Whether an org logo path COULD be copied into a survey's public snapshot —
 * so the unsaved-builder preview never shows a logo (SVG, GIF, …) that Create
 * would then drop. A hint by extension only: the API sniffs the bytes and caps
 * the size at 1 MB (`apps/api/src/lib/surveyLogoCopy.ts`), so a misnamed or
 * oversized file can still preview and then be skipped.
 */
export function isCopyableOrgLogoPath(path: string | null | undefined): path is string {
  if (!path) return false;
  const ext = path.split('/').pop()?.split('.').pop()?.toLowerCase() ?? '';
  return COPYABLE_LOGO_EXTENSIONS.has(ext);
}
